import { render, staticRenderFns } from "./TableauBord.vue?vue&type=template&id=5c52091b&scoped=true&"
import script from "./TableauBord.js?vue&type=script&lang=js&"
export * from "./TableauBord.js?vue&type=script&lang=js&"
import style0 from "./TableauBord.vue?vue&type=style&index=0&id=5c52091b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c52091b",
  null
  
)

export default component.exports